import Vue from 'vue';
import { memberBindingSa } from '../../../services/personnelService/bindSaService';

// initial state
// state 必為模組區域變數，取時需 store.state.auth.user
// 其他則視 default 內是否有設 namespaced = true 來決定是全域還是區域
// 區域使用時值需加上 name
const state = {
  saInfo: null
};

// getters
const getters = {};

// actions
const actions = {
  // 取得顧問 Profile
  async memberBindingSaHandler({}, bindingInfo) {
    const data = await memberBindingSa(bindingInfo);
    return data;
  }
};

// mutations
const mutations = {
  setSaInfo(state, data) {
    Vue.set(state, 'saInfo', data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
